
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';

@Component
export default class ChooseConfig extends Vue {

    @Getter backgroundIdDoc: any;
    @Action('getBackProductDocDTOById') getBackProductDocDTOById: Function;

    @Getter triggerMessage: any;
    @Action('setBackProductDocDTOById') setBackProductDocDTOById: Function;

    @Prop() choosePropVisible: boolean;
    @Prop() configGUID: string; // 接收父组件传递的 ConfigGUID

    formKey: number = 0; // 用于强制重新渲染表单

  handleInput(value: string) {
   // console.log('输入框内容:', value);
}
     // 关闭弹窗
     handleClose() {
        this.$emit('closeChoosePropVisible', false);
    }

//     @Watch('backgroundIdDoc', { deep: true })
// onBackgroundIdDocChange(newVal: any) {
//     if (newVal.data && newVal.data.length > 0) {
//         console.log('backgroundIdDoc 数据已更新:', JSON.stringify(newVal.data));
//         this.formKey += 1
//         console.log(this.formKey);
//         // this.$nextTick(() => {
//         //     // 确保 DOM 更新后，表单数据正确绑定
//         //     this.$refs.productForm.clearValidate(); // 清除表单验证
//         // });
//     }
// }

    // 观察 choosePropVisible 的变化
       @Watch('choosePropVisible')
    onChoosePropVisibleChange(newVal: boolean) {
        
        if (newVal) {
           // console.log("子表单页面");
            //console.log(this.configGUID);
            
            if (this.configGUID) {
                 // 清空旧数据
            this.backgroundIdDoc.data = [];
                this.getBackProductDocDTOById({ configGUID: this.configGUID}).then(() => {
                    // 数据加载完成后，可以在这里进行其他操作
                     console.log(JSON.stringify(this.backgroundIdDoc));  
                     //this.IDformData =   this.backgroundIdDoc.data;  
                     this.formKey += 1;                
            });
    }
            //this.onDialogOpen(); // 当 choosePropVisible 变为 true 时调用的方法
        }
    }
    //确定修改
    confirmbtn() {
        const collectedData = this.backgroundIdDoc.data.map(product => ({
            Code: product.Code,
            Value: product.Value,
            ConfigGUID:product.ConfigGUID
        }));
       // console.log('收集到的数据:', collectedData);
        this.setBackProductDocDTOById({ configDIList: collectedData}).then(() => {
            console.log("更新Data"+JSON.stringify(this.triggerMessage));
            if(this.triggerMessage.data ==='success'){
                this.$message.success("更新成功!");
            }else{
                this.$message.error(this.triggerMessage );
            }
        })
        this.$emit('refresh-product-data'); // 触发自定义事件
        this.handleClose(); // 关闭对话框
    }

}
